<ol class="breadcrumb float-xl-right">
  <li class="breadcrumb-item">Inicio</li>
  <li class="breadcrumb-item">Administración</li>
  <li class="breadcrumb-item active">Usuarios</li>
</ol>

<h1 class="page-header"><i class="fas fa-users"></i> Administración de Usuarios</h1>

<panel [noButton]="true">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div class="w-75">
      <div class="input-group input-group-sm">
        <input type="text" class="form-control" placeholder="Buscar usuario..." [(ngModel)]="search">
        <button class="btn btn-primary" (click)="getUsers()"><i class="fas fa-search"></i> Buscar</button>
      </div>
    </div>
    <button class="btn btn-sm btn-primary" (click)="open(modalUserForm)"><i class="fas fa-plus me-1"></i>Nuevo usuario</button>
  </div>

  <table class="table table-striped table-hover">
    <thead>
      <tr>
        <th class="text-center">N°</th>
        <th>Email</th>
        <th>Nombre</th>
        <th>Rol</th>
        <th>Campo</th>
        <th>Entidad</th>
        <th>Módulos</th>
        <th class="text-center col-1"><i class="fas fa-cogs"></i></th>
      </tr>
    </thead>
    <tbody>
      @if(users.length > 0){
      @for(user of users; track user.id; let i = $index){
      <tr>
        <td class="text-center">{{ (user.index ?? i) + 1 }}</td>
        <td>{{ user.mail }}</td>
        <td class="fw-500">{{ user.displayName }}</td>
        <td>{{ user.role?.name }}</td>
        <td>{{ user.office?.acronym }}</td>
        <td>@if (user.entity) { {{ user.entity?.name }} } @else { <span class="badge bg-warning text-dark">Sin entidad</span> }</td>
        <td class="text-center small">
          @for(m of user.modules ?? []; track m.id){
          <span class="badge bg-info me-1">{{m.name}}</span>
          }@empty {
          <span class="badge bg-warning text-dark">Sin módulos</span>
          }
        </td>
        <td class="text-center text-nowrap">
          <button class="btn btn-xs btn-ghost" (click)="moveUp(user, i)" [disabled]="i === 0"
            triggers="hover" ngbTooltip="Subir">
            <i class="fas fa-chevron-up"></i>
          </button>
          <button class="btn btn-xs btn-ghost" (click)="moveDown(user, i)" [disabled]="i === users.length - 1"
            triggers="hover" ngbTooltip="Bajar">
            <i class="fas fa-chevron-down"></i>
          </button>
          <button class="btn btn-xs btn-ghost" (click)="open(modalUserForm, user)" triggers="hover" ngbTooltip="Editar">
            <i class="fas fa-edit"></i>
          </button>
          <button class="btn btn-xs btn-ghost" (click)="checkAccess(user)" triggers="hover" ngbTooltip="Verificar acceso">
            <i class="fas fa-user-check"></i>
          </button>
          <button class="btn btn-xs btn-ghost" (click)="updateUser(user, !user.enabled)" triggers="hover" [ngbTooltip]="user.enabled ? 'Deshabilitar' : 'Habilitar'">
            <i class="fas" [class.fa-toggle-on]="user.enabled" [class.fa-toggle-off]="!user.enabled"></i>
          </button>
        </td>
      </tr>
      }
      } @else {
      <tr>
        <td colspan="8" class="text-center text-muted">No hay usuarios registrados</td>
      </tr>
      }
    </tbody>
  </table>
</panel>


<ng-template #modalUserForm let-c="close" let-d="dismiss">
  <div class="modal-header">
    <span class="fs-3 fw-700">Datos del Usuario</span>
  </div>
  <div class="modal-body" [formGroup]="newUserForm">
    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label fw-600">Email <span class="text-danger">*</span></label>
        <input type="email" class="form-control" placeholder="correo@dominio.cl" formControlName="mail" />
      </div>
      <div class="col-md-6">
        <label class="form-label fw-600">Rol <span class="text-danger">*</span></label>
        <ng-select [items]="roles" bindLabel="name" bindValue="id" formControlName="roleId" [clearable]="false" appendTo="body"></ng-select>
      </div>
      <div class="col-md-6">
        <label class="form-label fw-600">Campo <span class="text-danger">*</span></label>
        <ng-select [items]="offices" bindLabel="name" bindValue="id" formControlName="officeId" [clearable]="false" appendTo="body"></ng-select>
      </div>
      <div class="col-md-6">
        <label class="form-label fw-600">Entidad</label>
        <ng-select [items]="entities" bindLabel="name" bindValue="id" formControlName="entityId" [clearable]="false" appendTo="body"></ng-select>
      </div>
      <div class="col-md-12">
        <label class="form-label fw-600">Módulos asignados</label>
        <ng-select [items]="modules" bindLabel="name" bindValue="id"
          [(ngModel)]="selectedModules" [multiple]="true"
          [clearable]="false" appendTo="body" [ngModelOptions]="{standalone: true}">
        </ng-select>
        @if (!selectedModules.length) {
          <small class="text-warning">Sin módulos: el usuario verá solo menús estáticos.</small>
        }
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="d('Cross click')"><i class="fas fa-times me-1"></i> Cancelar</button>
    <button class="btn btn-primary" (click)="d('Cross click'); saveUser()"><i class="fas fa-save me-1"></i> Guardar</button>
  </div>
</ng-template>